export interface ValidateUniqueManagerPinRequestDto {

  /**
   * Manager Access Pin
   */
  managerAccessPin: string;
  /**
   * Cost Center Id
   */
  costCentreId: number;
  /**
   * Employee Id for who we validate the pin
   * This is `undefined` when user is not created in Backoffice create new employee
   */
  employeeId?: number;
}
